export default "__VITE_ASSET__BrpclqMv__"